import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import Keycloak from 'keycloak-js';
import { CoreProvider } from './core/core.provider';


@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html'
})
export class AppComponent {
  private readonly keycloak = inject(Keycloak);

  title = 'lote-3-web-app';

  constructor(private core: CoreProvider, private router: Router) {

    if (this.keycloak.authenticated) {
      this.keycloak.loadUserInfo().then((userInfo) => {
        this.core.utilsService.setUserInfo(userInfo);
      });
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const scrollToTop = () => {
          const position = window.pageYOffset;
          if (position > 0) {
            // Scroll más rápido: aumentar la velocidad con un factor mayor
            window.scrollTo(0, position - Math.max(40, position / 30));
            // Continuar el programa de scroll
            window.requestAnimationFrame(scrollToTop);
          }
        };

        // Iniciar la animación de scroll
        window.requestAnimationFrame(scrollToTop);
      }
    });
  }
}
